<template>
  <div id="app">
    <LanguageBannerAtom @languageChange="onLanguageChange" />
    <CookieBannerAtom v-if="showBanner" @acceptCookies="acceptCookies" @denyCookies="denyCookies" @closeBanner="closeBanner" />
    <div class="app">
      <HeaderAtom :light-theme="lightTheme" :transparentBackground="isTransparentBg" :isSmallerLogo="resizeLogo" />
      <main :class="{ 'light-theme': lightTheme }">
        <div />
        <router-view />
      </main>
      <FooterAtom v-if="!lightTheme" :light-theme="lightTheme" />
    </div>
  </div>
</template>

<script>
import { ref, provide } from 'vue';
import HeaderAtom from './components/atoms/HeaderAtom';
import FooterAtom from './components/atoms/FooterAtom';
import CookieBannerAtom from './components/atoms/CookieBannerAtom.vue';
import LanguageBannerAtom from './components/atoms/LanguageBannerAtom.vue';

export default {
  components: {
    HeaderAtom,
    FooterAtom,
    CookieBannerAtom,
    LanguageBannerAtom,
  },
  data() {
    return {
      showBanner: true,
    };
  },
  setup() {
    const selectedLanguage = ref(localStorage.getItem('selectedLanguage') || 'sv');

    const onLanguageChange = (newLanguage) => {
      selectedLanguage.value = newLanguage;
      localStorage.setItem('selectedLanguage', newLanguage);
    };

    provide('language', selectedLanguage); // Provide the language state for other components to use

    return {
      onLanguageChange,
    };
  },
  computed: {
    lightTheme() {
      return this.$route.meta.lightTheme;
    },
    isTransparentBg() {
      return this.$route.meta.isTransparentBg;
    },
    resizeLogo() {
      return this.$route.meta.resizeLogo;
    },
    cookiesAccepted() {
      return localStorage.getItem('cookiesAccepted') === 'true';
    },
    cookiesDenied() {
      return localStorage.getItem('cookiesDenied') === 'true';
    },
  },
  methods: {
    acceptCookies() {
      localStorage.setItem('cookiesAccepted', true);
      this.showBanner = false;
    },
    denyCookies() {
      this.showBanner = false;
      localStorage.setItem('cookiesDenied', true);
    },
    closeBanner() {
      this.showBanner = false;
    },
  },
  mounted() {
    if (this.cookiesAccepted || this.cookiesDenied) {
      this.showBanner = false;
    }
  },
};
</script>

<style>
@font-face {
  font-family: 'bred';
  src: url('fonts/soehne-breit-buch.woff2') format('woff2');
}
@font-face {
  font-family: 'fet';
  src: url('fonts/soehne-breit-fett.woff2') format('woff2');
}
@font-face {
  font-family: 'normal';
  src: url('fonts/soehne-buch.woff2') format('woff2');
}
@font-face {
  font-family: 'halvfet';
  src: url('fonts/soehne-dreiviertelfett.woff2') format('woff2');
}

* {
  color: white;
  font-family: 'bred', sans-serif;
  box-sizing: border-box;
}
</style>

<style scoped>
.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

main {
  flex-grow: 5;
  background-color: black;
}
.light-theme {
  background-color: white;
}

h1 {
  font-size: 36px;
}
h2 {
  font-size: 30px;
}
h3 {
  font-size: 24px;
}
</style>
